import 'whatwg-fetch';

export default {
  /**
   * Get abstraction for fetch.
   * @return {Promise}
   */
  get(endpoint) {
    return window.fetch(endpoint, {
      method: 'GET',
      headers: new Headers({ Accept: 'application/json' }),
      credentials: 'same-origin',
    })
      .then(handleResponse, handleError);
  },

  /**
   * Put abstraction for fetch.
   * @return {Promise}
   */
  put(endpoint, body) {
    return window.fetch(endpoint, {
      accept: '*/*',
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json; charset=UTF-8', Accept: 'application/json, text/javascript, */*;' }),
      body: JSON.stringify(body),
      credentials: 'same-origin',
    })
      .then(handleResponse, handleError);
  },

  /**
   * Post abstraction for fetch.
   * @return {Promise}
   */
  post(endpoint, body) {
    return window.fetch(endpoint, {
      accept: '*/*',
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json; charset=UTF-8', Accept: 'application/json, text/javascript, */*;' }),
      body: JSON.stringify(body),
      credentials: 'same-origin',
    })
      .then(handleResponse, handleError);
  },
};

/**
 * Handle a response from the server, returning either the JSON if the response is ok or throwing a standardised error
 * object for all non-successful HTTP codes. NB fetch only rejects for networking errors meaning we have to handle these
 * codes here.
 * @param response
 */
function handleResponse(response) {
  if (response.ok) {
    return response.json().catch(error => {
      throw {
        status: 0,
        statusText: error.message,
      };
    });
  }
  throw {
    status: response.status,
    statusText: response.statusText,
  };
}

/**
 * Handle networking errors and throw a standardised error object.
 * @param error
 */
function handleError(error) {
  throw {
    status: 0,
    statusText: error.message,
  };
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/api/api.js